import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 0.999999L7 4L13 1",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1 6L7 9L13 6",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }